<script>
export default {
    name: 'tabpanel',
    props: {
        header: null,
        disabled: Boolean
    },
    render() {
        return null;
    }
}
</script>